import Link from 'next/link';
import { useRouter } from 'next/router';
import { images } from '../../../../Constants/ImageUrls';
import { removeDefaultParams } from '../../../../Utils/helper';
import { fireBackgroundClickEvent } from '../../../../Utils/StoreHomePageUtils';
import {
  BestSellerButton,
  BestSellerContent,
  BestSellerDescriptionContainer,
} from './styled';

function BestSellingDescription(props) {
  const { data } = props;
  const router = useRouter();
  return (
    <BestSellerDescriptionContainer
      onClick={() => {
        fireBackgroundClickEvent(data);
      }}
      image={data?.sectionBgImage}
      // desktopImage={data?.desktopSectionBgImage}
      flexDirection={data.showCta ? 'row' : 'column'}
    >
      <BestSellerContent>
        <h3>{data?.heading}</h3>
        <p>{data?.subHeading}</p>
      </BestSellerContent>
      <Link
        href={{
          pathname: data?.viewAllDeeplinkValue,
          query: removeDefaultParams(router.query),
        }}
        passHref
        locale={false}
        legacyBehavior
      >
        <BestSellerButton as="a">
          {data?.showCta ? (
            <div>
              {data?.ctaText}
              <img src={images.arrowDownForward} alt="arrow" />
            </div>
          ) : null}
        </BestSellerButton>
      </Link>
    </BestSellerDescriptionContainer>
  );
}

export default BestSellingDescription;
